module.exports = __webpack_public_path__ + "media/images/recruit/common/android-chrome-256x256-4558f6a51695f162b9002262ad6fe40a.png";